function Order(container) {
    var sectionId = container.getAttribute('data-section-id'),
        check = {
            cart:function (e) {
                fetch(theme.routes_cart_url + '.js').then(function(r) {
                    return r.json();
                }).then(function(j) {
                    var its = j.items;
                    for (i = 0, len = its.length; i < len; i++) {
                        let it = its[i],
                            iq = it.quantity,
                            id = it.id,
                            ti = document.querySelectorAll('[data_id="' + id + '"]') || null;
                            er = document.querySelectorAll('[data_error_id="' + id + '"]') || null;
                        ti.forEach(function(t) {
                            t.setAttribute('value', iq);
                            t.closest('.item-row').classList.add('item-in-cart');
                        });
                        er.forEach(function(e) {
                            e.style.display = 'block';
                            e.textContent = theme.language.collections_general_update_cart_label_message;
                        });
                    }
                });
            }
        };
    function cart_change(q) {
        var it = q.closest('.item'),
            id = it.getAttribute('data-product-id'),
            q =  it.querySelector('.item-qty').value,
            iQ = it.querySelector('.item-qty'),
            iB = it.querySelectorAll('.qtybtn'),
            s = it.querySelector('.error');
        document.querySelectorAll('.item[data-product-id="' + id + '"] .item-qty').forEach(function(i) {
            i.value = q;
        });
        if (it.classList.contains('item-in-cart')) {
            var u = theme.routes_cart_change_url;
        } else {
            var u = theme.routes_cart_add_url;
        }
        fetch(u + '.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({'quantity': q,'id':id})
        }).then(function(r) {
            return r.json();
        }).then(function(j) {
            iB.forEach(function(i) {
                i.setAttribute('disabled', true)
            });
            if (j.status == 'bad_request') {
                console.log('Request returned an error', j) 
            } else {            
                CartDrop();
                document.dispatchEvent(new CustomEvent('cartItems', {
                    bubbles: true
                }));
                var v = iQ.value,
                    x = iQ.getAttribute('max');
                if (v < x && v > 0 ) {
                } else if (v == 0) {
                    s.style.display = 'none';
                    s.html = '';
                }
                if (q > 0) {
                    it.classList.add('item-in-cart');
                } else {
                    it.classList.remove('item-in-cart');
                }
                iB.forEach(function(i) {
                    i.removeAttribute('disabled');
                });
            }
        }).catch(function(err) {
            console.error('!: ' + err)
        });
    }
    var cart = {
        buttons:function (e) {
            var qB = container.querySelectorAll('.qtybtn');
            qB.forEach(function(q) {                
                setTimeout(function () {
                    q.onclick = function(ev){
                    var qF = q.closest('.qtyOpt.form'),
                        vV = qF.querySelector('.item-qty').getAttribute('value'),
                        vM = qF.querySelector('.item-qty').getAttribute('max'),
                        vL = qF.querySelector('.item-qty').getAttribute('min');              
                    if (q.classList.contains('icon-plus')) {
                        var currentVal = vV;
                        if (isNaN(currentVal)) {
                            var currentVal = 0; 
                        };
                        nV = ++currentVal;
                        if (vM && vV == vM && nV > vM) {
                            return;
                        }                
                    };               
                    if (q.classList.contains('icon-minus')) {
                        var currentVal = vV;
                        if (isNaN(currentVal)) {
                            var currentVal = 2; 
                        };
                        nV = --currentVal;
                        if (vV == vL && vL > nV) {
                            return;
                        }
                    };
                    cart_change(q);
                    }
                }, 1);
            })  ;
            var qI = container.querySelectorAll('.item-qty');
            qI.forEach(function(q) {
                let timeout;
                var vV = q.value,
                    vM = q.getAttribute('max'),
                    vL = q.getAttribute('min');            
                q.addEventListener('keyup', function (e) {
                    if (e.key == 'Tab' || e.key == 'Shift') return;
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        cart_change(q);
                    }, 750);
                });
            });
        }
    };
    cart.buttons();
    check.cart();
    Quantity(container);
}

document.addEventListener('Section:Loaded', function(event){
  let sectionContainer = event.detail;
  let sectionType = sectionContainer.dataset.sectionType;
  if(sectionType === 'order'){
    Order(sectionContainer);
  }
})

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;  
  if(sectionType === 'order' && !sectionContainer.classList.contains('ignore')){
    Order(sectionContainer);
    sectionContainer.classList.add('ignore');
  }
})